import { BaseQueue } from "./strategies/BaseQueue";
import { QueueStrategy } from "./types";
import { v4 } from "uuid";
import { JobMissingError } from "./errors";

/**
 * Jobs are processed in the order determined by strategy
 * onRunningChange allows for state management
 */
export class Queue extends BaseQueue {
  constructor(
    private queueStrategy: QueueStrategy,
    private onRunningChange: (running: boolean) => void
  ) {
    super();
  }

  private running = false;

  get isRunning() {
    return this.running;
  }

  enqueue(job: () => Promise<void>) {
    const key = v4();
    BaseQueue.enqueue(key, job);
  }

  getNextJob() {
    return this.queueStrategy.getNext(Array.from(BaseQueue.queue));
  }

  async processNext() {
    const result = this.queueStrategy.getNext(Array.from(BaseQueue.queue));
    if (this.running) return;

    if (!result) throw JobMissingError;

    const [key] = result;

    this.handleRunningChange(true);

    return BaseQueue.processJob(key).finally(() =>
      this.handleRunningChange(false)
    );
  }

  async processAll() {
    if (this.running || !this.hasNext) return;

    this.handleRunningChange(true);

    while (this.hasNext) {
      try {
        const result = this.queueStrategy.getNext(Array.from(BaseQueue.queue));
        if (!result) throw JobMissingError;

        const [key] = result;

        await BaseQueue.processJob(key);
      } catch (e) {
        console.error(e);
      }
    }

    this.handleRunningChange(false);
  }

  handleRunningChange(running: boolean) {
    this.running = running;
    this.onRunningChange(this.running);
  }
}
